import React, { useState, useEffect } from "react";
import Button from "../form/Button";
import Input from "../form/Input";

import { postData } from "../../services/api";
import toastr from "toastr";

import { useTranslation } from "react-i18next";
import { classNames } from "../../helper/classNames";
import Textarea from "../form/Textarea";

const BoardPositionPopup = ({
  isOpen,
  setIsOpen = () => {},
  data,
  setData = () => {},
  loadList = () => {},
  isAdmin = false,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  //const [positions, setPosition] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [responsibility, setResponsibility] = useState([
    {
      title: "",
      description: "",
    },
  ]);
  const [qualifications, setQualifications] = useState("");
  const [timeCommitment, setTimeCommitment] = useState("");

  const closeModal = () => {
    setIsOpen(false);
    setData({});
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let payload;
    let url;
    if (data?._id) {
      payload = {
        name,
        position_summary: description,
        key_responsibilities: responsibility,
        qualifications,
        time_commitment: timeCommitment,
        id: data?._id,
      };
      url = "/board/position-update";
    } else {
      payload = {
        name,
        position_summary: description,
        key_responsibilities: responsibility,
        qualifications,
        time_commitment: timeCommitment,
      };
      url = "/board/position-create";
    }
    try {
      setLoading(true);
      const result = await postData(url, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setIsOpen(false);
        setLoading(false);
        setData({});
        loadList();
      } else {
        toastr.error(result.message);
        setLoading(false);
        closeModal();
      }
    } catch (error) {
      toastr.error(error.message);
      setLoading(false);
      closeModal();
    }
  };

  // useEffect(() => {
  //   async function positionData() {
  //     try {
  //       const result = await postData("position/list", {
  //         sortQuery: { created_at: 1 },
  //         status: 1,
  //       });
  //       if (result.data) {
  //         setPosition(result.data);
  //       } else {
  //         console.log("Position list message", result.message);
  //       }
  //     } catch (error) {
  //       console.log("Error position list catch", error.message);
  //     }
  //   }
  //   positionData();
  // }, []);

  useEffect(() => {
    if (data?._id) {
      const key_responsibilities = data?.key_responsibilities;
      setName(data?.name);
      setDescription(data?.company_position_competencies);
      setQualifications(data?.qualifications);
      setTimeCommitment(data?.time_commitment);
      setResponsibility(
        Array.isArray(data?.key_responsibilities) &&
          data.key_responsibilities.length > 0
          ? data.key_responsibilities
          : [
              {
                title: "",
                description: "",
              },
            ]
      );
    }
  }, [data]);

  const addResponsibilitiesRow = async () => {
    setResponsibility([
      ...responsibility,
      {
        title: "",
        subTitle: [
          {
            responsibility: "",
            responsible_party: "",
          },
        ],
      },
    ]);
  };

  const removeResponsibilitiesRow = async (index) => {
    responsibility.splice(index, 1);
    setResponsibility(
      responsibility.map((it, idx) => {
        return it;
      })
    );
  };

  const handelResponsibilitiesUpdate = async (value, field, index) => {
    responsibility[index][field] = value;
    setResponsibility(
      responsibility.map((it, idx) => {
        if (idx === index) {
          return {
            ...it,
            [field]: value,
          };
        } else {
          return it;
        }
      })
    );
  };

  return (
    <>
      <div className="relative z-50 overflow-hidden w-full">
        <div
          className={classNames(
            "fixed inset-0 bg-black bg-opacity-25 transition-all duration-300 ease-in-out",
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          )}
        />
        <div
          className={classNames(
            "fixed inset-0 overflow-y-auto transition-transform duration-300",
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          )}
        >
          <div className="flex h-screen justify-end w-full overflow-hidden">
            <div
              className={classNames(
                "w-full flex flex-col max-w-2xl rounded-l-2xl p-4 bg-white text-left align-middle shadow-xl transition-all duration-300",
                isOpen ? "translate-x-0" : "translate-x-full"
              )}
            >
              <div className="relative flex-shrink-0">
                <h3 className="text-lg font-medium leading-6 text-gray-900 text-center mb-4">
                  {t("manage_board_position")}
                </h3>
                <div className="absolute -top-4 -right-4 z-10">
                  <Button
                    buttonLabelClasses=""
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-times"}
                    buttonIconPosition={"left"}
                    buttonLabel={""}
                    buttonClasses={
                      "!bg-transparent !text-slate-700 !w-10 !h-10 !p-0"
                    }
                    functions={closeModal}
                    buttonHasLink={false}
                  />
                </div>
              </div>
              <div className="space-y-4 px-2 py-2 mt-3 overflow-auto scroll-smooth scrollbar max-h-[calc(100vh-150px)]">
                <div className="relative space-y-2">
                  <div className="relative w-full">
                    <Input
                      requiredDisplay={true}
                      label={t("position_name")}
                      labelClasses={"!text-xs"}
                      inputType={"text"}
                      inputPlaceholder={t("enter_position_name")}
                      inputValue={name}
                      setInput={setName}
                    />
                  </div>
                  <div className="relative w-full">
                    <Textarea
                      label={t("position_summary")}
                      labelClasses={"!text-xs"}
                      inputValue={description}
                      inputPlaceholder={t("enter_position_summary")}
                      setTextarea={setDescription}
                      requiredDisplay={true}
                    />
                  </div>
                  <div className="relative w-full border border-slate-300 px-2 py-2 mt-2 rounded-md space-y-2">
                    {responsibility &&
                      responsibility.map((item, index) => (
                        <>
                          <div className="relative pr-8 sm:pr-10 space-y-2">
                            <div className="w-full">
                              <Input
                                label={
                                  index === 0 ? t("key_responsibilities") : ""
                                }
                                labelClasses={"!text-xs"}
                                inputType={"text"}
                                inputPlaceholder={t("enter_title")}
                                inputValue={item?.title}
                                setInput={(val) =>
                                  handelResponsibilitiesUpdate(
                                    val,
                                    "title",
                                    index
                                  )
                                }
                              />
                            </div>
                            <div className="w-full">
                              <Textarea
                                label={""}
                                labelClasses={"!text-xs"}
                                inputValue={item?.description}
                                inputPlaceholder={t("enter_description")}
                                setTextarea={(val) =>
                                  handelResponsibilitiesUpdate(
                                    val,
                                    "description",
                                    index
                                  )
                                }
                              />
                            </div>
                            {index === 0 ? (
                              <Button
                                buttonIcon={"fa-light fa-plus"}
                                buttonIconPosition={"left"}
                                buttonClasses={
                                  "!h-6 !w-6 !min-w-[24px] !text-sm !p-0 absolute top-0 right-0"
                                }
                                buttonType={"button"}
                                functions={(e) => addResponsibilitiesRow()}
                                buttonHasLink={false}
                              />
                            ) : (
                              <Button
                                buttonIcon={"fa-light fa-minus"}
                                buttonIconPosition={"left"}
                                buttonClasses={
                                  "!h-6 !w-6 !min-w-[24px] !text-sm !p-0 !bg-rose-500 absolute top-0 right-0"
                                }
                                buttonType={"button"}
                                functions={(e) =>
                                  removeResponsibilitiesRow(index)
                                }
                                buttonHasLink={false}
                              />
                            )}
                          </div>
                        </>
                      ))}
                  </div>
                  <div className="w-full">
                    <Textarea
                      label={""}
                      labelClasses={"!text-xs"}
                      inputValue={qualifications}
                      inputPlaceholder={t("enter_qualification")}
                      setTextarea={setQualifications}
                    />
                  </div>
                  <div className="w-full">
                    <Textarea
                      label={""}
                      labelClasses={"!text-xs"}
                      inputValue={timeCommitment}
                      inputPlaceholder={t("enter_time_commitment")}
                      setTextarea={setTimeCommitment}
                    />
                  </div>
                </div>
              </div>

              <div className="relative flex justify-center mt-2 gap-4">
                <Button
                  buttonClasses="!bg-teal-500"
                  buttonLabelClasses=""
                  buttonType={"button"}
                  buttonIcon={
                    loading
                      ? "fa-light fa-spinner fa-spin"
                      : "fa-light fa-check"
                  }
                  buttonIconPosition={"left"}
                  buttonLabel={t("confirm")}
                  functions={onSubmit}
                  buttonHasLink={false}
                />
                <Button
                  buttonLabelClasses=""
                  buttonType={"button"}
                  buttonIcon={"fa-light fa-times"}
                  buttonIconPosition={"left"}
                  buttonLabel={t("cancel")}
                  buttonClasses={
                    "!bg-slate-200 !text-slate-600 border border-slate-300"
                  }
                  functions={closeModal}
                  buttonHasLink={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoardPositionPopup;
